import {
	SET_PERSPECTIVE,
	SET_CREATED_CONFIGURATION,
	SET_IMAGE_TIMESTAMP,
	SET_PRICE,
	SET_CULTURE,
	EXIT_VEHICLE_CONFIGURATION,
	SET_CONFIGURATION_ID,
	SET_CONFIGURATION_IMAGES,
	SET_COMPANY_ID,
	SET_COUNTRY,
	PRESERVE_SAVE_DETAILS_DATA,
	SET_ENTRY_POINT_URL,
	CATEGORY_SCROLL_POSITION,
	SET_CONFIGURATION_WAS_RECENTLY_CREATED,
	SET_CONFIGURATION_IS_DIRTY
} from "../actionTypes";
import Action from "./models/action";
import { CreateConfigurationResponse } from "../../components/configuration/ConfigurationView";
import { Price } from "../../components/main/motorcycles/MotorcycleView";
import { SaveDetailsData } from "../../components/dialogs/saveConfiguration";

const initialCustomerData: CustomerData = {
	name: "",
	surname: "",
	email: "@",
	comment: ""
};

const initialSaveDetailsData: SaveDetailsData = {
	Vin: "",
	OrderNumber: "",
	Firstname: "",
	Lastname: "",
	Comment: ""
};

export interface ConfigurationState {
	configuration: CreateConfigurationResponse;
	perspective: number;
	price: Price;
	imageTimestamp: number;
	culture: string;
	market: string;
	companyId: string;
	customer: CustomerData;
	entryPointUrl: string;
	categoryScrollPosition: number;
	wasRecentlyCreated: boolean;
	isDirty: boolean;
	preservableSaveDetails: SaveDetailsData;
}

export interface CustomerData {
	name?: string;
	surname?: string;
	email?: string;
	comment?: string;
}

export const initialConfigurationState: ConfigurationState = {
	configuration: {} as CreateConfigurationResponse,
	perspective: 0,
	price: {
		CurrencySymbol: "",
		Value: 0
	},
	imageTimestamp: 0,
	culture: process.env.REACT_APP_DEFAULT_CULTURE as string,
	market: "",
	companyId: "",
	customer: { ...initialCustomerData },
	entryPointUrl: "",
	categoryScrollPosition: 0,
	wasRecentlyCreated: true,
	isDirty: false,
	preservableSaveDetails: { ...initialSaveDetailsData }
};

export default function ConfigurationReducer(
	state: ConfigurationState = initialConfigurationState,
	action: Action
): ConfigurationState {
	switch (action.type) {
		case SET_PERSPECTIVE: {
			return {
				...state,
				perspective: action.payload
			};
		}
		case SET_CREATED_CONFIGURATION: {
			return {
				...state,
				configuration: action.payload
			};
		}
		case SET_CONFIGURATION_ID: {
			return {
				...state,
				configuration: {
					...state.configuration,
					ConfigurationId: action.payload
				}
			};
		}
		case SET_CONFIGURATION_IMAGES: {
			return {
				...state,
				configuration: {
					...state.configuration,
					FullImages: action.payload
				}
			};
		}
		case SET_PRICE: {
			return {
				...state,
				price: action.payload
			};
		}
		case SET_IMAGE_TIMESTAMP: {
			return {
				...state,
				imageTimestamp: Date.now()
			};
		}
		case SET_CULTURE: {
			return {
				...state,
				culture: action.payload
			};
		}
		case SET_COMPANY_ID: {
			return {
				...state,
				companyId: action.payload
			};
		}
		case SET_COUNTRY: {
			return {
				...state,
				market: action.payload
			};
		}
		case EXIT_VEHICLE_CONFIGURATION: {
			return {
				...initialConfigurationState,
				culture: state.culture,
				market: state.market,
				companyId: state.companyId,
				entryPointUrl: state.entryPointUrl
			};
		}
		case SET_ENTRY_POINT_URL: {
			return {
				...state,
				entryPointUrl: action.payload
			};
		}
		case CATEGORY_SCROLL_POSITION: {
			return {
				...state,
				categoryScrollPosition: action.payload
			};
		}
		case PRESERVE_SAVE_DETAILS_DATA: {
			return {
				...state,
				preservableSaveDetails: action.payload
			};
		}
		case SET_CONFIGURATION_WAS_RECENTLY_CREATED: {
			return {
				...state,
				wasRecentlyCreated: action.payload
			};
		}
		case SET_CONFIGURATION_IS_DIRTY: {
			return {
				...state,
				isDirty: action.payload
			};
		}
		default:
			return state;
	}
}
